"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLoggerPayloadSchema = void 0;
exports.DashboardLoggerPayloadSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        eventHandler: {
            type: 'string',
            minLength: 5,
        },
        environment: {
            type: 'string',
            minLength: 3,
        },
        eventType: {
            type: 'string',
        },
        eventDate: {
            type: 'string',
        },
        error: {
            type: 'object',
        },
        data: {
            type: ['object', 'string', 'array'],
        },
        tag: {
            type: 'string',
            minLength: 5,
        },
        logType: {
            type: 'string',
        },
        origin: {
            type: 'string',
        },
    },
    required: [
        'eventHandler',
        'environment',
        'tag',
    ],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,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